import {
  BaseActionObject,
  DoneInvokeEvent,
  StateNodeConfig,
  assign
} from "xstate4"
import { Context, Transitions } from "../../../../types"
import { StudyPlanSectionType } from "../../../../../../study-plans/types"
import { getServiceErrorMessage } from "../../../../helpers"

export const getPlanAvailableItemsTransition: StateNodeConfig<
  Context,
  {},
  Transitions,
  BaseActionObject
> = {
  invoke: {
    src: "getPlanAvailableItems",
    onDone: {
      target: "idle",
      actions: assign<Context, DoneInvokeEvent<any>>((ctx, evt) => {
        const targetSections = (
          ctx.recommendedStudyPlan ??
          ctx.studyPlan ??
          ctx.publishedStudyPlan
        )?.sections as StudyPlanSectionType[]
        const selectedSection = targetSections.find(
          section => section.id === ctx.selectedSectionId
        )

        if (!selectedSection) return

        if (selectedSection.type === "MASTERY_LESSON") {
          return { lessonOptions: evt.data.masteryLessons }
        }

        if (selectedSection.type === "PRACTICE_TEST") {
          return { lessonOptions: evt.data.practiceTests }
        }

        return {
          lessonOptions: evt.data
        }
      })
    },
    onError: {
      target: "idle",
      actions: assign<Context, DoneInvokeEvent<any>>({
        snackbar: (_ctx, _evt) => ({
          message: getServiceErrorMessage("getPlanAvailableItems", {
            messageData: ["get available items"]
          }),
          withUndo: false,
          error: true
        })
      })
    }
  }
}
